__webpack_require__.p = "/academy-qr-code-replacement/onboarding/";